import React from 'react';
import './modalPopUp.less';

class ModalPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          isOpen : props.isOpen
        }
        this.close = this.close.bind(this);
    }
    close(){
      this.setState({
        isOpen : false
      })
    }
    render() {
      const imageUrl = "../../public/images/landing/ship_a_package.png";
        return (
            <div className={this.state.isOpen? 'modalPopUp-wrapp': 'displayNone'}>
                <div className="overlay" onClick={this.close}></div>
                <div className="modal">
                    <div className="close-button">
                      <span className="icon-cross-feather cursor-pointer" onClick={this.close}></span>
                    </div>
                    <div className="modal-content">
                      <div className="imgDiv" style = {{"backgroundImage": 'url("' + imageUrl + '")'}}></div>
                      <div className="heading">Welcome!</div>
                      <div className="content">
                        The web version of AWB will allow you to easily post , accept packages to carry and
                        track your shipments. You can also download our app from below.
                      </div>
                      <div className="store-links">
                        <a className="link" target="_blank" href="http://play.google.com/store/apps/details?id=com.awb.android">
                          <img className="playstore-img" src="../public/images/landing/playstore.png"/>
                        </a>
                        <a className="link" target="_blank" href="https://itunes.apple.com/us/app/airwaybill/id1198529029?ls=1&mt=8">
                          <img className="appstore-img" src="../public/images/landing/appstore.png"/>
                        </a>
                      </div>
                      <div className="continue-div">
                        <span className="continue-text cursor-pointer" onClick={this.close}>Continue to web version</span>
                      </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalPopUp;



// WEBPACK FOOTER //
// app/components/modalPopUp/modalPopUp.jsx